module.exports = __webpack_public_path__ + "static/media/S Support 2.857f1fd3.webp";